import { MarketActivityWindow } from '../graphql.generated';

export const getNumMonthsString = (numMonths: string) =>
    (({
        all: 'ALL',
        '3': 'THREE_MONTHS',
        '6': 'SIX_MONTHS',
        '12': 'TWELVE_MONTHS',
        '60': 'FIVE_YEARS',
        '120': 'TEN_YEARS',
        '240': 'TWENTY_YEARS'
    }[numMonths] || 'ALL') as MarketActivityWindow);
